import { render, staticRenderFns } from "./Programmes.vue?vue&type=template&id=fb3e76b0&"
import script from "./Programmes.vue?vue&type=script&lang=js&"
export * from "./Programmes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports